"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exeIfEventOutside = void 0;

var exeIfEventOutside = function exeIfEventOutside(e, domain, fun) {
  var _domain$current;

  // get the event's target
  var target = e.target; // execute if the target is domain element or one of its descendants

  if (!((_domain$current = domain.current) !== null && _domain$current !== void 0 && _domain$current.contains(target))) fun();
};

exports.exeIfEventOutside = exeIfEventOutside;